/* ═══════════════════════════════════════════════════════════════
   ALTERLY — In-Flight Connection Wire Draft
   Dynamic Bézier curve following pointer during wire creation.
   ═══════════════════════════════════════════════════════════════ */

import React from 'react';
import type { PortType } from '../../domain/types';

interface ConnectionDraftProps {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  sourceType: PortType;
}

const PORT_COLOR_MAP: Record<PortType, string> = {
  color: '#e8b4f8',
  number: '#a9e1f7',
  image: '#8fe46c',
  mask: '#f8d84e',
  text: '#f0f0ee',
  boolean: '#63d9db',
  any: '#9b9b97',
};

export const ConnectionDraft: React.FC<ConnectionDraftProps> = ({
  x1,
  y1,
  x2,
  y2,
  sourceType,
}) => {
  const dx = Math.max(40, Math.abs(x2 - x1) * 0.5);
  const pathData = `M ${x1} ${y1} C ${x1 + dx} ${y1}, ${x2 - dx} ${y2}, ${x2} ${y2}`;
  const strokeColor = PORT_COLOR_MAP[sourceType] || '#b99af8';

  return (
    <g style={{ pointerEvents: 'none' }}>
      {/* Outer ambient glow */}
      <path
        d={pathData}
        fill="none"
        stroke={strokeColor}
        strokeWidth="6"
        strokeOpacity="0.25"
        strokeLinecap="round"
      />
      {/* Main wire */}
      <path
        d={pathData}
        fill="none"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeDasharray="5 3"
        strokeLinecap="round"
      />
      {/* Tip circle */}
      <circle cx={x2} cy={y2} r="4" fill={strokeColor} />
    </g>
  );
};
